import { css } from 'styled-components';
import { CFTokens } from '../../../tokens';
//
// Tokens
//
export const CFBaseDotBadgeTokens = {
    ALTERNATE_BORDER_COLOR: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
    BORDER_COLOR: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
    COLOR: {
        alert: CFTokens.COLOR.TEXT_AND_ELEMENT_DANGER,
        alternate: CFTokens.COLOR.TEXT_AND_ELEMENT_ALTERNATE_DEFAULT,
        boost: CFTokens.COLOR.TEXT_AND_ELEMENT_BOOST,
        brand: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
        default: CFTokens.COLOR.TEXT_AND_ELEMENT_EMPHASIS,
    },
    SIZE: {
        lg: 12,
        md: 8,
    },
};
//
// Helpers
//
export const CFBaseDotBadgeHelpers = {
    border: ({ $border, $color }) => {
        if (!$border)
            return null;
        let borderColor = $color === 'alternate'
            ? CFBaseDotBadgeTokens.ALTERNATE_BORDER_COLOR
            : CFBaseDotBadgeTokens.BORDER_COLOR;
        if (typeof $border === 'string')
            borderColor = CFTokens.getCFColorValue($border);
        return css `
      border: 1px solid ${borderColor};
    `;
    },
    color: ({ $color }) => {
        if (Object.keys(CFBaseDotBadgeTokens.COLOR).includes($color)) {
            return CFBaseDotBadgeTokens.COLOR[$color];
        }
        return CFTokens.getCFColorValue($color);
    },
    position: ({ $position }) => {
        if (!$position)
            return null;
        const { bottom, left, right, top } = $position;
        return css `
      position: absolute;
      ${top !== undefined
            ? css `
            top: ${top}px;
          `
            : null}
      ${right !== undefined
            ? css `
            right: ${right}px;
          `
            : null}
    ${bottom !== undefined
            ? css `
            bottom: ${bottom}px;
          `
            : null}
    ${left !== undefined
            ? css `
            left: ${left}px;
          `
            : null}
    `;
    },
    size: ({ $size, $border }) => {
        let dotSize = $size;
        if (typeof $size === 'string')
            dotSize = CFBaseDotBadgeTokens.SIZE[$size];
        if ($border)
            dotSize += 2;
        return css `
      width: ${dotSize}px;
      height: ${dotSize}px;
    `;
    },
};
//
// Element Styles
//
export const CFBaseDotBadgeStyles = {
    Root: css `
    background-color: ${CFBaseDotBadgeHelpers.color};
    border-radius: ${CFTokens.BORDER_RADIUS.PILL}px;
    ${CFBaseDotBadgeHelpers.border};
    ${CFBaseDotBadgeHelpers.position};
    ${CFBaseDotBadgeHelpers.size};
  `,
};
